import axios from 'src/utils/axios';
import { requests } from '../constants/config';

export const SESSION_USUARIOS_REQUEST = 'SESSION_USUARIOS_REQUEST';
export const SESSION_USUARIOS_SUCCESS = 'SESSION_USUARIOS_SUCCESS';
export const SESSION_USUARIOS_FAIL = 'SESSION_USUARIOS_FAIL';

export const SESSION_USUARIOS_UPDATE_REQUEST = 'SESSION_USUARIOS_UPDATE_REQUEST';
export const SESSION_USUARIOS_UPDATE_SUCCESS = 'SESSION_USUARIOS_UPDATE_SUCCESS';
export const SESSION_USUARIOS_UPDATE_FAIL = 'SESSION_USUARIOS_UPDATE_FAIL';

export const getUsuarios = (searchParams) => async (dispatch) => {
    dispatch({ type: SESSION_USUARIOS_REQUEST });
    const config = {
        method: 'post',
        url: requests.usuarios.listado,
        data: searchParams
    };

    try {
        const { data } = await axios(config);
        dispatch({ type: SESSION_USUARIOS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SESSION_USUARIOS_FAIL,
            payload: error.response && error.response.data.error_description
                ? error.response.data.error_description
                : 'Ocurrió un error'
        });
    }
};

export const update = (data) => async (dispatch) => {
    dispatch({ type: SESSION_USUARIOS_UPDATE_REQUEST });
    const config = {
        method: 'post',
        url: requests.usuarios.listado,
        data: data
    };

    try {
        const { data } = await axios(config);
        dispatch({ type: SESSION_USUARIOS_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: SESSION_USUARIOS_UPDATE_FAIL,
            payload: error.response && error.response.data.error_description
                ? error.response.data.error_description
                : 'Ocurrió un error'
        });
    }
};
